import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Icon from '../../../components/AppIcon';
import { apiService } from '../../../services/apiService';

const LoginForm = () => {
  const navigate = useNavigate();
  
  const [formData, setFormData] = useState({
    username: '',
    password: '',
    rememberMe: false
  });
  
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const validateForm = () => {
    const newErrors = {};

    if (!formData?.username?.trim()) {
      newErrors.username = 'Usuário é obrigatório';
    }

    if (!formData?.password) {
      newErrors.password = 'Senha é obrigatória';
    } else if (formData?.password?.length < 6) {
      newErrors.password = 'A senha deve ter pelo menos 6 caracteres';
    }

    setErrors(newErrors);
    return Object.keys(newErrors)?.length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e?.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
    
    if (errors?.[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const handleSubmit = async (e) => {
    e?.preventDefault();

    if (!validateForm()) {
      return;
    }

    setIsLoading(true);
    setErrors({});

    try {
      // Authenticate using apiService
      const response = await apiService.login(formData?.username, formData?.password);
      
      // Store user session in localStorage
      localStorage.setItem('adminUser', JSON.stringify(response?.user));
      
      navigate('/admin-dashboard');
    } catch (err) {
      setErrors({ general: err?.message || 'Credenciais inválidas' });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="w-full max-w-md">
      <form onSubmit={handleSubmit} className="space-y-6">
        {errors?.general && (
          <div className="p-4 bg-red-500/10 border border-red-500 rounded-lg flex items-start gap-3">
            <Icon name="AlertCircle" size={20} color="#ef4444" />
            <div className="flex-1">
              <p className="text-sm font-medium text-red-500">{errors?.general}</p>
            </div>
          </div>
        )}
        <div className="space-y-2">
          <label htmlFor="username" className="block text-sm font-medium text-foreground">
            Usuário
          </label>
          <Input
            id="username"
            name="username"
            type="text"
            value={formData?.username}
            onChange={handleInputChange}
            placeholder="seu_usuario"
            className={errors?.username ? 'border-red-500' : ''}
            disabled={isLoading}
          />
          {errors?.username && (
            <p className="text-sm text-red-500 flex items-center gap-1">
              <Icon name="AlertCircle" size={14} />
              {errors?.username}
            </p>
          )}
        </div>

        <div className="space-y-2">
          <label htmlFor="password" className="block text-sm font-medium text-foreground">
            Senha
          </label>
          <Input
            id="password"
            name="password"
            type="password"
            value={formData?.password}
            onChange={handleInputChange}
            placeholder="••••••••"
            className={errors?.password ? 'border-red-500' : ''}
            disabled={isLoading}
          />
          {errors?.password && (
            <p className="text-sm text-red-500 flex items-center gap-1">
              <Icon name="AlertCircle" size={14} />
              {errors?.password}
            </p>
          )}
        </div>

        <div className="flex items-center justify-between">
          <label className="flex items-center gap-2 cursor-pointer">
            <input
              type="checkbox"
              name="rememberMe"
              checked={formData?.rememberMe}
              onChange={handleInputChange}
              className="w-4 h-4 text-primary bg-muted border-border rounded focus:ring-primary focus:ring-2"
              disabled={isLoading}
            />
            <span className="text-sm text-muted-foreground">Lembrar-me</span>
          </label>
        </div>

        <Button
          type="submit"
          className="w-full glow-primary"
          disabled={isLoading}
        >
          {isLoading ? (
            <div className="flex items-center justify-center gap-2">
              <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
              <span>Entrando...</span>
            </div>
          ) : (
            <div className="flex items-center justify-center gap-2">
              <Icon name="LogIn" size={20} />
              <span>Entrar</span>
            </div>
          )}
        </Button>
      </form>
    </div>
  );
};

export default LoginForm;